module.exports = __webpack_public_path__ + "img/in.c7afcb01.svg";